<template>
  <grouped-table
    ref="groupedTableRef"
    :groups="policyGroups"
    group-row-key="key"
    :group-columns="policyColumns"
    items-key="coverages"
    item-row-key="key"
    :item-columns="coverageColumns"
    :item-slot-names="itemSlotNames"
    :detail-title="(group) => `Coberturas de la póliza ${group.numberPolicy}`"
    default-expanded="none"
    :loading="loading"
  >
    <template #title>
      <div class="table-title">
        <span>Coberturas seleccionadas</span>
        <a-space>
          <a-button size="small" @click="groupedTableRef?.expandAll()">
            Expandir todo
          </a-button>
          <a-button size="small" @click="groupedTableRef?.collapseAll()">
            Contraer todo
          </a-button>
        </a-space>
      </div>
    </template>

    <template #coverages="{ record }">
      <span class="summary">
        <span class="summary-count">{{ record.coverageCount }}</span>
        <span class="summary-detail">{{ coverageSummary(record) }}</span>
        <a-tag v-if="countPendingCoverages(record)" color="orange">
          {{ countPendingCoverages(record) }}
          {{
            countPendingCoverages(record) === 1 ? 'pendiente' : 'pendientes'
          }}
        </a-tag>
      </span>
    </template>

    <!-- Items are the original coverage objects, so the selection is kept
         in the list the ticket validates and submits. -->
    <template #itemSelected="{ record }">
      <a-radio-group
        :options="radioOptions"
        v-model:value="record.selected"
        :disabled="record.required"
      />
    </template>
  </grouped-table>
</template>

<script setup>
import { computed, defineProps, ref } from 'vue';
import GroupedTable from '@/components/tables/grouped-table.vue';
import {
  countPendingCoverages,
  countSelectedCoverages,
  groupCoveragesByPolicy
} from '@/utils/incorporationDetailGroups';

const props = defineProps({
  // Ticket coverages with numberPolicy, groupName, nameCoverage, required
  // and selected.
  coverages: {
    type: Array,
    default: () => []
  },
  loading: {
    type: Boolean,
    default: false
  }
});

const groupedTableRef = ref();

const policyGroups = computed(() => groupCoveragesByPolicy(props.coverages));

const radioOptions = [
  {
    label: 'Sí',
    value: true
  },
  {
    label: 'No',
    value: false
  }
];

const itemSlotNames = ['itemSelected'];

const policyColumns = [
  {
    title: 'N° Póliza',
    dataIndex: 'numberPolicy',
    key: 'numberPolicy'
  },
  {
    title: 'Coberturas',
    key: 'coverages',
    slots: { customRender: 'coverages' }
  }
];

const coverageColumns = [
  {
    title: 'Grupo',
    dataIndex: 'groupName',
    key: 'groupName'
  },
  {
    title: 'Cobertura',
    dataIndex: 'nameCoverage',
    key: 'nameCoverage'
  },
  {
    title: 'Seleccionada',
    key: 'selected',
    slots: { customRender: 'itemSelected' }
  }
];

const coverageSummary = (group) => {
  const selected = countSelectedCoverages(group);
  return `${selected} ${selected === 1 ? 'seleccionada' : 'seleccionadas'}`;
};
</script>

<style scoped>
.table-title {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
.summary {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}
.summary-count {
  display: inline-grid;
  place-items: center;
  min-width: 22px;
  height: 22px;
  padding: 0 7px;
  border-radius: 11px;
  background: #eeeafe;
  color: #231a8c;
  font-size: 12px;
  font-weight: 600;
}
.summary-detail {
  color: #8b939b;
  font-size: 13px;
}
</style>
